<div class="row pane-container">
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <h2>{{ 'step1_download_and_fill_template' | translate }}</h2>
      </div>
    </div>

    <div class="row py-1">
      <div class="col-12">
        <button class="btn button-link-style" data-test-id="download-template" (click)="downloadTemplate()">
          {{ 'download_XLSX_template' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <h2 class="margin-top">{{ 'step2_upload_template' | translate }}</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <form [formGroup]="formBulk" (ngSubmit)="createBulk()">
          <app-common-file-dropbox
            [fullWidth]="modalMode"
            [form]="formBulk"
            [acceptedFileTypes]="ACCEPTED_FILE_TYPES"
            [fileValid]="fileValid"
            [fileUploaded]="fileUploaded"
            [fileUploadedMessage]="FILE_UPLOADED_MESSAGE"
            [acceptedFileError]="ACCEPTED_FILE_ERROR"
            [fileDataError]="FILE_DATA_ERROR"
            (emitFile)="inputFile($event)"
            (clickedValidate)="validate()"
            (rebuildForm)="buildForm()"
          >
            @if (fileValid === false) {
              <div errorTable>
                <ds-pagination
                  [page]="page$ | async"
                  [collectionSize]="(validateErrors$ | async).length"
                  (pageChange)="onPageChange($event)"
                  [hidePaginationNavigation]="true"
                ></ds-pagination>
                <div class="table-wrapper my-2">
                  <app-ngb-table [config]="tableConfig" [data]="tableData$ | async" (onSort)="onSort($event)"></app-ngb-table>
                </div>
                <ds-pagination
                  [page]="page$ | async"
                  [collectionSize]="(validateErrors$ | async).length"
                  (pageChange)="onPageChange($event)"
                ></ds-pagination>
              </div>
            }
          </app-common-file-dropbox>
          <div class="row mt-4">
            <!-- see EAP-25117 -->
            @if (fileValid !== true) {
              <div class="col-auto">
                <button ds-button type="submit" [disabled]="true">
                  {{ 'add_workspaces' | translate }}
                </button>
              </div>
            }
            @if (fileValid) {
              <div class="col-auto">
                <button ds-button type="submit" [disabled]="false">
                  {{ 'add_workspaces' | translate }}
                </button>
              </div>
            }
            <div class="col-auto">
              @if (modalMode) {
                <button
                  ds-button
                  type="button"
                  [variant]="DsButtonVariants.secondary"
                  (click)="cancelled.emit()"
                  data-test-id="cancel-button"
                >
                  {{ 'label_cancel' | translate }}
                </button>
              } @else {
                <a ds-button [variant]="DsButtonVariants.secondary" [routerLink]="tenantDetailsUrl" id="cancelLink">
                  {{ 'label_cancel' | translate }}
                </a>
              }
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
